<template>
  <div>
    <el-dialog
      center
      :title="modalTitle"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      :visible.sync="modals.tabulator"
      :key="tabulatorKey"
    >
      <tabulator-card
        id="nonsense"
        :tableData="tabulatorData"
        :tableOptions="tabulatorOptions"
        :tableColumns="tabulatorColumns"
      >
        <template slot="header">
          <h4 class="card-title">{{mainCategory.selected}} By {{category.selected}}</h4>
        </template>
      </tabulator-card>
    </el-dialog>
    <chartjs-pie-card
      v-if="dataIsNotEmpty"
      :chart-data="chartData"
      :chart-options="chartOptions"
      style="/*min-height:475px*/"
    >
      <template slot="header">
        <!-- <div style="display: flex; justify-content: space-between;"> -->
        <div class="d-flex">
          <!-- <h4
            class="flex-grow-1 card-title dashboard-cards-header"
          >Portfolio Value By {{this.category.title}}</h4>-->
          <div class="flex-grow-1 card-title dashboard-cards-header">
            <div class="d-flex">
              <div>
                <el-select
                  class="dashboardCategoryDropdown-el-select dashboardCategoryDropdown1 dashboardPiechart-el-select select-primary"
                  size="small"
                  placeholder="Select Portfolio Graph"
                  @change="mainCategoryChange"
                  v-model="mainCategory.selected"
                >
                  <el-option
                    v-for="option in mainCategoryDropdown"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  ></el-option>
                </el-select>
              </div>
              <div style v-tooltip.top-end="toolTipInfo">
                <img src="static/img/graphInfo.svg" class />
              </div>
            </div>
          </div>
          <div class="d-flex">
            <el-select
              class="dashboard-dropdown-el-select select-primary"
              size="small"
              placeholder="Select Value Graph"
              v-model="category.selected"
              @input="categoryChanged"
            >
              <el-option
                v-for="option in categoryOptions"
                class="select-primary"
                :label="option.label"
                :key="option.label"
                :value="option.value"
              ></el-option>
            </el-select>
            <div class="hlpicon pt-1" v-tooltip.top-end="toolTipInfo" style="display:none">
              <i class="fa fa-question-circle" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </template>
    </chartjs-pie-card>
  </div>
</template>
<script>
import {
  vals,
  formatCurrency,
  subsetBackground,
  formatNumber,
  formatNumberWithComma
} from "../../../util";
import { Select, Option, Dialog } from "element-ui";
import { ChartjsPieCard, TabulatorCard } from "src/components/index";
import { mapGetters } from "vuex";
import util from "util";
import _ from "lodash";

function numberSorter(a, b, aRow, bRow, column, dir, sorterParams) {
  // if either is undefined, treat is a 0
  return (!_.isNil(a) ? a : 0) - (!_.isNil(b) ? b : 0);
}

export default {
  name: "pie-portfolio-chart-card",
  components: {
    [Dialog.name]: Dialog,
    [Option.name]: Option,
    [Select.name]: Select,
    [ChartjsPieCard.name]: ChartjsPieCard,
    [TabulatorCard.name]: TabulatorCard
  },
  computed: {
    ...mapGetters("charts", [
      "portfolioValueByProperty",
      "topCompaniesByPropertyValue",
      "portfolioOtherByValue",
      "otherCompaniesByPropertyValue",
      "dashboardPortfolioValueByProperty",
      "dashboardTopCompaniesByPropertyValue",
      "dashboardPortfolioOtherByValue",
      "dashboardOtherCompaniesByPropertyValue"
    ]),
    ...mapGetters("portfolio", ["hasData", "portfolioCount"]),
    ...mapGetters("user", ["currency"]),
    categoryOptions() {
      // get all of the non-numerical values
      let retval = [];
      retval = _.map(vals.GRAPH_OPTIONS, v => {
        let label = _.has(vals.HEADER_MAP, v)
          ? `By ${vals.HEADER_MAP[v]}`
          : _.startCase(v);
        return { label, value: v };
      });
      return _.without(retval, undefined, null);
    },
    chartData() {
      const self = this;
      self.category.title = _.has(vals.HEADER_MAP, self.category.selected)
        ? vals.HEADER_MAP[self.category.selected]
        : _.startCase(self.category.selected);
      let data = {
        labels: _.flatten(self.computedLabels),
        datasets: self.computedDataset
      };
      return data;
    },
    chartOptions() {
      const self = this;
      // let d = self.chartData
      let options = {
        cutoutPercentage: this.cutoutPercentage,
        plugins: {
          doughnutlabel: {
            labels: this.textCenterLabel
          }
        },
        tooltips: {
          backgroundColor: "#fff",
          titleFontFamily: "custom-helvetica-bold",
          titleFontColor: "#000",
          bodyFontFamily: "custom-helvetica-bold",
          bodyFontColor: "#000",
          footerFontFamily: "custom-helvetica",
          footerFontSize: 10,
          footerFontColor: "#000",
          footerFontStyle: "lighter",
          callbacks: {
            label: function(toolTipItem, data) {
              return (
                (data.datasets[toolTipItem.datasetIndex].header_label[
                  toolTipItem.index
                ] || "") +
                ": " +
                (data.datasets[toolTipItem.datasetIndex].data[
                  toolTipItem.index
                ] || "") +
                "%"
              );
            },
            footer: function(toolTips, data) {
              let toolTipItem = toolTips[0];
              let value =
                data.datasets[toolTipItem.datasetIndex].data_value[
                  toolTipItem.index
                ] || 0;
              //return formatCurrency(value, self.currency.ref, 0, true);
              return self.mainCategory.selected == "Portfolio Value"
                ? `$${formatNumberWithComma(value)}`
                : value > 1
                ? `${value} Companies`
                : `${value} Company`;
            }
          }
        },
        maintainAspectRatio: false,
        responsive: true,
        legend:
          self.computedLabels && self.computedLabels.length > 0
            ? {
                position: "bottom",
                align: "center",
                labels: {
                  boxWidth: 10,
                  fontSize: 10,
                  fontColor: "#000",
                  fontFamily: "custom-helvetica,roboto"
                }
              }
            : { display: false },
        onClick: function(unused, toolTips) {
          let toolTipItem = toolTips[0];
          self.secondaryData = false;
          if (!_.isNil(toolTipItem)) {
            if (toolTipItem._datasetIndex === 0) {
              // only 'drill-down' if it is a primary value
              let data = toolTipItem._chart.data;
              let propertyValue =
                data.datasets[toolTipItem._datasetIndex].header_label[
                  toolTipItem._index
                ];
              self.addDatasetForProperty(
                self.category.selected,
                propertyValue,
                toolTipItem._index
              );
              let portfolioValue =
                data.datasets[toolTipItem._datasetIndex].data_value[
                  toolTipItem._index
                ];
              if (self.mainCategory.selected == "Portfolio Value") {
                let obj = {
                  text: propertyValue,
                  font: {
                    size: "12",
                    family: "custom-helvetica-medium,roboto"
                  },
                  color: "#050505"
                };
                let dataObj = {
                  text: `$${formatNumberWithComma(portfolioValue)}`,
                  font: {
                    size: "25",
                    family: "custom-helvetica-medium,roboto"
                  },
                  color: "#050505"
                };
                self.textCenterLabel[0] = obj;
                self.textCenterLabel[1] = dataObj;
              } else {
                let propertyObj = {
                  text: propertyValue,
                  font: {
                    size: "12",
                    family: "custom-helvetica-medium,roboto"
                  },
                  color: "#050505"
                };
                let countDataObj = {
                  text: portfolioValue,
                  font: {
                    size: "25",
                    family: "custom-helvetica-medium,roboto"
                  },
                  color: "#050505"
                };
                let countTextObj = {
                  text: portfolioValue > 1 ? "Companies" : "Company",
                  font: {
                    size: "12",
                    family: "custom-helvetica-medium,roboto"
                  },
                  color: "#050505"
                };
                self.textCenterLabel[0] = propertyObj;
                self.textCenterLabel[1] = countDataObj;
                self.textCenterLabel[2] = countTextObj;
              }
            } else if (toolTipItem._datasetIndex === 1) {
              // second tier
              // if label has 'Other' then we want to show table data
              let data = toolTipItem._chart.data;
              let propertyValue =
                data.datasets[toolTipItem._datasetIndex].header_label[
                  toolTipItem._index
                ];
              // make sure we have a path and that the path has 'Other' as its leaf
              if (propertyValue.includes("/")) {
                let split = propertyValue.split("/");
                // if (split[1].includes("Other")) {
                //   self.secondaryData = true;
                //   self.category.secondaryTitle = "Company";
                //   self.category.secondaryFilter = split[0].trim();
                //   // show the table data
                //   self.modals.tabulator = true;
                // }
                let actualCompany = self.$store.getters[
                  "portfolio/portfolioAll"
                ].find(item => {
                  if (item.name == split[1].trim()) {
                    return item;
                  }
                });
                let account_id = self.$route.params.account_id;
                let workspace_id = actualCompany.workspace;
                if (actualCompany.ucid) {
                  let ucid = actualCompany.ucid;
                  self.$store.commit("temp/currentCompany", ucid);
                  self.$router.push(
                    `/${account_id}/${workspace_id}/companyProfile/${ucid}`
                  );
                }
              }
            }
          }
        }
      };
      return options;
    },
    computedDataset() {
      return this.datasets;
    },
    computedLabels() {
      return this.labels;
    },
    dataIsNotEmpty() {
      // if (this.version !== this.localVersion) {
      //   this.localVersion = this.version
      //   this.createPrimaryDataset()
      // }
      return this.portfolioCount > 0;
    },
    tabulatorColumns() {
      const self = this;
      let selected = self.category.selected;
      let title = self.secondaryData
        ? self.category.secondaryTitle
        : self.category.title;
      return [
        {
          title: title,
          field: selected,
          sorter: "string"
        },
        {
          title: "Percentage",
          field: "value_p",
          sorter: "number",
          formatter: function(cell, params) {
            if (_.isNil(cell.getValue()) || cell.getValue() === 0) return "N/A";
            return cell.getValue() + "%";
          }
        },
        {
          title: "Value",
          field: "value",
          sorter: numberSorter,
          formatter: "money",
          formatterParams: this.currency.format
        }
      ];
    },
    tabulatorData() {
      const self = this;
      let property = self.category.selected;
      let data = self.tabulatorRawData;
      let retval = [];
      if (self.secondaryData) {
        for (let i = 0; i < data.value.length; i++) {
          retval.push({
            [property]: data.names[i],
            value: data.value[i],
            value_p: data.value_p[i]
          });
        }
      } else {
        for (let i = 0; i < data.value.length; i++) {
          retval.push({
            [property]: data[property][i],
            value: data.value[i],
            value_p: data.value_p[i]
          });
        }
      }
      return retval;
    },
    tabulatorOptions() {
      return {
        layout: "fitColumns",
        tooltips: true,
        tooltipsHeader: true,
        initialSort: [{ column: "value_p", dir: "desc" }]
      };
    },
    tabulatorRawData() {
      const self = this;
      if (self.secondaryData) {
        return self.dashboardOtherCompaniesByPropertyValue(
          self.category.selected,
          self.category.secondaryFilter
        );
      } else {
        return self.dashboardPortfolioOtherByValue(
          self.category.selected,
          self.mainCategory.selected
        );
      }
    },
    toolTipInfo() {
      const self = this;
      // // different based on what has been selected
      // let retval = self.toolTip; // default
      // if (_.has(vals.GRAPHS.TOOLTIP_VALUE_INFO, self.category.selected)) {
      //   retval = vals.GRAPHS.TOOLTIP_VALUE_INFO[self.category.selected];
      // }
      // return retval;
      if (self.mainCategory.selected == "Portfolio Value") {
        if (self.category.selected == "sector") {
          return `Shows the consolidated Value of all investments in your portfolio across sectors. Selecting one of the sectors displays the list of companies in that sector.. Selecting one of the companies in the inner circle will take you to that company.`;
        }
        if (self.category.selected == "geography") {
          return `Shows the consolidated Value of all investments in your portfolio across Geography. Selecting one of the geographic areas displays the list of companies in that area. Selecting one of the companies in the inner circle will take you to that company.`;
        }
        if (self.category.selected == "stage") {
          return `Shows the consolidated Value of all investments in your portfolio across Stages. Selecting one of the stages displays the list of companies in that stage. Selecting one of the companies in the inner circle will take you to that company.`;
        }
        if (self.category.selected == "status") {
          return `Shows the consolidated Value of all investments in your portfolio across Status. Selecting a status section displays the list of companies with that status. Selecting one of the companies in the inner circle will take you to that company.`;
        }
      } else {
        if (self.category.selected == "sector") {
          return `Shows the total number of companies in your portfolio across sectors. Selecting one of the sectors displays the list of companies in that sector. Selecting one of the companies in the inner circle will take you to that company.`;
        }
        if (self.category.selected == "geography") {
          return `Shows the total number of companies in your portfolio across Geography. Selecting one of the geographic areas displays the list of companies in that area. Selecting one of the companies in the inner circle will take you to that company.`;
        }
        if (self.category.selected == "stage") {
          return `Shows the total number of companies in your portfolio across Stage. Selecting one of the stages displays the list of companies in that stage. Selecting one of the companies in the inner circle will take you to that company.`;
        }
        if (self.category.selected == "status") {
          return `Shows the total number of companies in your portfolio across Status. Selecting a status section displays the list of companies with that status. Selecting one of the companies in the inner circle will take you to that company.`;
        }
      }
    },
    mainCategoryDropdown() {
      let dropDownArray = [];
      dropDownArray[0] = { label: "Portfolio Value", value: "Portfolio Value" };
      dropDownArray[1] = { label: "Portfolio Count", value: "Portfolio Count" };
      return dropDownArray;
    }
  },
  data() {
    return {
      category: {
        selected: "sector",
        title: "Sector",
        secondaryFilter: "",
        secondaryTitle: ""
      },
      dataIsEmpty: true,
      datasets: [],
      labels: [],
      localVersion: 0,
      modals: { tabulator: false },
      modalTitle: "",
      tabulatorKey: 0,
      secondaryData: false,
      mainCategory: {
        selected: "Portfolio Value",
        title: "Portfolio Value",
        secondaryFilter: "",
        secondaryTitle: ""
      },
      textCenterLabel: []
    };
  },
  props: {
    defaultSelected: {
      type: String,
      default: undefined
    },
    cutoutPercentage: {
      type: Number,
      default: 60
    },
    toolTip: {
      type: String,
      default() {
        return `This chart shows a comparison of the total value of different groups in the same category.`;
      }
    },
    defaultMainCategorySelected: {
      type: String,
      default: undefined
    }
  },
  methods: {
    addDatasetForProperty(property, value, index) {
      const self = this;
      if (value !== "Other") {
        //let values = self.topCompaniesByPropertyValue(property, value);
        let values = self.dashboardTopCompaniesByPropertyValue(
          property,
          value,
          self.mainCategory.selected
        );
        // check to see if have an other section
        let hasOther = _.reduce(
          values.names,
          (m, n) => {
            return m || n === "Other";
          },
          false
        );
        if (index > 9) index = index - 10;
        let bgColors = _.concat(
          subsetBackground(index),
          subsetBackground(index)
        );
        if (hasOther && values.value.length <= bgColors.length) {
          // we want 'other' to be grey (default color) - remove colors so that other is 'empty'
          bgColors = _.slice(bgColors, 0, values.value.length - 1);
        }
        // create the dataset...
        let dataset = {
          header_label: _.map(values.names, n => {
            return value + " / " + n;
          }),
          data: values.value_p,
          data_value: values.value,
          backgroundColor: bgColors
        };
        // if there is already a second dataset, remove it
        if (self.datasets.length > 1)
          self.datasets = _.slice(self.datasets, 0, 1);
        // add new one
        self.datasets.push(dataset);
        self.datasets = _.without(self.datasets, undefined, null);
      } else {
        // want to 'drill down' the other category to get the next top x values in the category
        // show this as a tabulator modal
        self.modals.tabulator = true;
      }
    },
    categoryChanged(obj1) {
      // regenerate primary dataset
      this.textCenterLabel = [];
      this.createPrimaryDataset();
      this.tabulatorKey++;
    },
    createPrimaryDataset() {
      const self = this;
      // only do check if there is data (and it is local)
      if (!self.hasData || self.portfolioCount < 1) return;
      // do initial calculate for chart data
      self.datasets = [];
      self.labels = [];
      //let portfolioInfo = self.portfolioValueByProperty(self.category.selected);
      let portfolioInfo = self.dashboardPortfolioValueByProperty(
        self.category.selected,
        self.mainCategory.selected
      );
      let labels = portfolioInfo[self.category.selected];
      labels = _.map(labels, lbl => {
        lbl = _.startCase(lbl);
        return lbl.length > 12 ? _.truncate(lbl, { length: 12 }) : lbl;
      });
      self.labels.push(labels);
      // create background colors...
      let bgColors = _.concat(
        vals.LEGEND.BACKGROUND_COLORS_1,
        vals.LEGEND.BACKGROUND_COLORS_2
      );
      self.datasets.push({
        header_label: portfolioInfo[self.category.selected],
        data: portfolioInfo["value_p"],
        data_value: portfolioInfo["value"],
        backgroundColor: bgColors
      });
    },
    mainCategoryChange() {
      // regenerate primary dataset
      this.textCenterLabel = [];
      this.createPrimaryDataset();
      this.tabulatorKey++;
    }
  },
  mounted() {
    const self = this;
    if (
      !_.isNil(self.defaultSelected) &&
      !_.isNil(self.defaultMainCategorySelected)
    ) {
      self.category.selected = self.defaultSelected;
      self.category.title = _.startCase(self.defaultSelected);
      self.mainCategory.selected = self.defaultMainCategorySelected;
      self.mainCategory.title = _.startCase(self.defaultMainCategorySelected);
    }
    self.createPrimaryDataset();
  },
  watch: {
    portfolioCount: {
      handler(newData) {
        // updated portfolio, run update
        if (newData > 0) this.createPrimaryDataset();
      }
    }
  }
};
</script>
<style>
.dashboardPiechart-el-select .el-input {
  width: 155px !important;
}
</style>